//Files Taxes:
export const UNKNOWN = "unknown";
export const YES = "yes";
export const NO = "no";

//Gender:
export const FEMALE = "female";
export const MALE = "male";

//Anchor IDs for scrolling to sections in Manage Patient Details
export const MISSING_ELEMENT_ANCHORS = {
  coverage: "manage-patient-details-coverages",
  drug: "manage-patient-details-medications",
  diagnosis: "manage-patient-details-diagnosis"
};
